import Component from './Supply.vue';

export default {
  install(Vue) {
    Vue.component('BkfIconSupply', Component);
  },
};
